/** Condition kind in the rule for importing documents from a bank statement */
export enum BankStatementRuleConditionKindEnum {
  /** Company */
  COMPANY = 'COMPANY',
  /** Company bank details */
  COMPANY_BANK_DETAILS = 'COMPANY_BANK_DETAILS',
  /** Counterparty */
  CONTRAGENT = 'CONTRAGENT',
  /** Date */
  DATE = 'DATE',
  /** Amount value */
  AMOUNT = 'AMOUNT',
}
